<template>
  <div class="select_date">
    <el-form :inline="true" label-width="40px">
      <!-- 其它页签 时间范围查询条件 -->
      <el-form-item :label="$t('time')">
        <el-date-picker
          v-model="query.logTimestampBegin"
          :placeholder="$t('pleaseSelecDate')"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="date"
        >
        </el-date-picker>
        <!-- <el-date-picker
          v-model="query.logTimestampBegin"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="date"
          placeholder="选择日期">
        </el-date-picker> -->
        <span class="lest_to"> ~ </span>
        <el-date-picker
          v-model="query.logTimestampEnd"
          :placeholder="$t('pleaseSelecDate')"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="date"
          clearable
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item class="btn">
        <!-- <el-button type="primary" @click="searchData" class="serachBtn" size="small">
          {{ $t('query') }}
        </el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    searchDate: {
      type: Object,
    },
  },
  data() {
    return {
      query: {
        // 日期查询
        logTimestampBegin: this.searchDate.startTime,
        logTimestampEnd: this.searchDate.endTime,
      },
    }
  },
  methods: {
    searchData() {
      // 查询返回时间
      this.$emit('handleSearch', this.query)
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.select_date
  display: flex
  align-items: center
  padding-left: 10px
  border-radius: 4px;
  .lest_to
    color: #333
  >>>.el-date-editor
    width 140px !important;/*no*/
    .el-input__prefix
      .el-input__icon
        // display: none
>>>.el-date-editor .el-input__inner
  height: 36px;/*no*/
  line-height 36px;/*no*/
  border-radius: 2px;
>>>.el-form-item
  margin-right: 12px!important;
  .el-button
    padding 10px!important
.btn
  margin-right: 0!important;
>>>.el-form-item
  margin-bottom: 0!important;
>>>.el-input--small .el-input__inner
  height 36px;/*no*/
  line-height 36px;/*no*/
>>>.el-form-item__label
  font-weight: bold;
.theme-dark
  .lest_to
    color: #fff
</style>
